module.exports = __webpack_public_path__ + "static/media/server3.48349877.png";